import { PlanRegisterPage } from '@/features/plans/pages/plan-register-page';

const PlanRegisterRoute = () => {
  return <PlanRegisterPage />;
};

export default PlanRegisterRoute;
